import { Text ,Float, Environment, useGLTF, PresentationControls, ContactShadows, Html } from '@react-three/drei'

export default function Experience()
{
    const computer = useGLTF('https://threejs-journey.com/resources/models/macbook_model.gltf')
    return <>

        <Environment preset='city' />

        <color attach="background" args={['#241a1a']} />

        <PresentationControls
            global
            rotation={ [0.13, 0.1, 0] }
            polar={ [ -0.4, 0.2 ] } // Y
            azimuth={ [ -1, 0.75 ] } // X
            config={ { mass: 2, tension: 400 } }
            snap={ { mass: 4, tension: 400 } }
        >
            <Float rotationIntensity={ 0.4 }>
                <rectAreaLight
                    width={ 2.5 }
                    height={ 1.65 }
                    intensity={ 70 }
                    color={ '#ff6900' }
                    rotation={ [ 0.1, Math.PI, 0 ] }
                    position={ [ 0, 0.55, - 1.15 ] }
                />
                <primitive object={computer.scene} position-y={ -1.2 }>
                    <Html
                        transform
                        wrapperClass='htmlScreen'
                        distanceFactor={ 1.17 }
                        position={ [ 0, 1.55, - 1.4 ] }
                        rotation-x={ - 0.256 }
                    >
                        <iframe src="https://unfor-sliced-model.vercel.app/" />
                    </Html>
                </primitive>
                <Text
                    position={ [ 2, 0.85, 0.1 ] }
                    rotation-y={ - 1.25 }
                    fontSize={ 0.55 }
                    color='#ff6901'
                    font='./bangers-v20-latin-regular.woff'
                    maxWidth={ 2 }
                    textAlign='center'
                >
                    Unfor 🥳 Dev
                </Text>
            </Float>
        </PresentationControls>

        <ContactShadows position-y={ -1.4 } opacity={ 0.4 } scale={ 5 } blur={ 2.4 } />
    </>
}
